export function stringCharLimitTo(string = '', limitNumber = 120) {
  if (string && string.length > limitNumber) {
    string = string.slice(0, limitNumber - 3);
    string += '...';
  }
  return string;
}

export function toTitleCase(str = '') {
  return str.replace(/\w\S*/g, function(txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}
